import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableProductsComponent from '../components/TableProductsComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

class ProductsPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole
        };
    }

    async componentDidMount() {
        const role = await validateSession(true);
        this.setState({ checked: true, role });
    }

    getProductTypeFilter = () => {
        if (this.props.forcedProductType != null) {
            return Number(this.props.forcedProductType);
        }

        const params = new URLSearchParams(this.props.location.search);
        const productType = Number(params.get('productType'));
        return productType === 1 || productType === 2 ? productType : null;
    }

    getSubtitle = () => {
        const productType = this.getProductTypeFilter();

        if (productType === 1) {
            return 'Juegos';
        }

        if (productType === 2) {
            return 'Accesorios';
        }

        return 'Productos';
    }

    addProduct = () => {
        const productType = this.getProductTypeFilter();
        navigateTo(productType == null
            ? '/addProduct'
            : `/addProduct?productType=${productType}`);
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }

        const productTypeFilter = this.getProductTypeFilter();
        const redirectPath = `${this.props.location.pathname}${this.props.location.search}`;

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={4} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4" style={{ paddingBottom: '80px' }}>
                            <HeaderComponent title="Dashboard" subtitle={this.getSubtitle()} />
                            <TableProductsComponent
                                role={this.state.role}
                                productTypeFilter={productTypeFilter}
                                redirectPath={redirectPath}
                            />
                        </div>
                    </main>
                </div>

                <div onClick={() => this.addProduct()} className="color-switcher-toggle animated pulse infinite">
                    <i className="material-icons">add</i>
                </div>
            </div>
        );
    }
}

export default ProductsPage;
